export enum DIVISION_CODE {
  CEMENT = '02',
  MULTI_PRODUCT = '09',
}

export type DivisionCodesTypes = DIVISION_CODE.CEMENT | DIVISION_CODE.MULTI_PRODUCT;

const productLineIdToDivisionCodeMap = new Map<number, DivisionCodesTypes>([
  [1, DIVISION_CODE.CEMENT],
  [2, DIVISION_CODE.CEMENT],
  [3, DIVISION_CODE.MULTI_PRODUCT],
]);

export const getDivisionCodeFromProductLineId = (productLineId: number): DivisionCodesTypes => {
  return productLineIdToDivisionCodeMap.get(productLineId);
};
